import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import React from 'react'
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import { FetchBranchShowData, FetchSectionShowData, FetchSemesterShowData, FetchSpecializationShowData, LocationShowdata, StudentGetSection, StudentGetSemester, StudentTransferData, StudentTransferShowdata } from '../../services/LoginPageService';
import { useEffect } from 'react';
import TransferView from './TransferView';

const StudentTransfer = () => {
    const[location,setLocation]=useState('');
    const[locationList,setLocationList]=useState([]);
    const[branch,setBranch]=useState('');
    const[branchList,setBranchList]=useState([]);
    const[specialization,setSpecialization]=useState('');
    const[specializationList,setSpecializationList]=useState([]);
    const[semester,setSemester]=useState('');
    const[semesterList,setSemesterList]=useState([]);
    const[section,setSection]=useState('');
    const[sectionList,setSectionList]=useState([]);
    const[semesterTo,setSemesterTo]=useState('');
    const[semesterListTo,setSemesterListTo]=useState([]);
    const[sectionTo,setSectionTo]=useState('');
    const[sectionListTo,setSectionListTo]=useState([]);
    const[refreshData, setRefreshData] = useState(false);
    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState('');
    const [openNotification, setNotification] = useState({
        status: false,
        type: 'error',
        message: '',
    });
    
    const handleClickOpen = () => {
        StudentTransferShowdata({
            location: location,
            branch  : branch,
            specialization:specialization,
            semester:semester,  
            section:section,
        }, handleViewTransferShowdata,handleViewTransferShowdataException);
        setOpen(true);
    };

    const handleViewTransferShowdata= (dataObject) =>{
        setRows(dataObject?.message); 
    }

    const handleViewTransferShowdataException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }
    
    useEffect(()=>{
        LocationShowdata(handleLocationshow,handleLocationshowException);
    },[refreshData])

    const handleLocationshow=(dataObject)=>{
        setLocationList(dataObject?.data);
        console.log(dataObject?.data);
    }

    const handleLocationshowException=(error,errorMessage)=>{
        console.log(errorMessage);
    }

    const onLocationChange=(e)=>{
        setLocation(e.target.value);  
        FetchBranchShowData({id:e.target.value},handleBranchSuccess, handleBranchException);
    }

    const handleBranchSuccess = (dataObject) =>{
        setBranchList(dataObject.data);
    }

    const handleBranchException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onBranchChange=(e)=>{
        setBranch(e.target.value);     
        FetchSpecializationShowData({id:e.target.value},handleSpecializationSuccess, handleSpecializationException);    
    }

    const handleSpecializationSuccess = (dataObject) =>{
        setSpecializationList(dataObject.data);
    }

    const handleSpecializationException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onSpecializationChange=(e)=>{
        setSpecialization(e.target.value);
        StudentGetSemester({
            location:location,
            branch:branch ,
            specialization:e.target.value
        },handleGetSemesterSuccess, handleGetSemesterException);
        FetchSemesterShowData({id:e.target.value},handleFetchSemesterSuccess, handleFetchSemesterException);  
    }

    const handleGetSemesterSuccess = (dataObject) =>{
        setSemesterList(dataObject.data);
    }

    const handleGetSemesterException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const handleFetchSemesterSuccess = (dataObject) =>{
        setSemesterListTo(dataObject.data);
    }

    const handleFetchSemesterException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onSemesterChange=(e)=>{
        setSemester(e.target.value);
        StudentGetSection({
            location:location,
            branch:branch,
           specialization :specialization,
           semester : e.target.value
        },handleGetSectionSuccess, handleGetSectionException)
    }

    const handleGetSectionSuccess = (dataObject) =>{
        setSectionList(dataObject.data);
    }

    const handleGetSectionException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onSectionChange=(e)=>{
        setSection(e.target.value);
    }

    const onSemesterToChange=(e)=>{
        setSemesterTo(e.target.value);
        FetchSectionShowData({id:e.target.value},handleFetchSectionSuccess, handleFetchSectionException); 
    }

    const handleFetchSectionSuccess = (dataObject) =>{
        setSectionListTo(dataObject.data);
    }

    const handleFetchSectionException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    const onSectionToChange=(e)=>{
        setSectionTo(e.target.value);
    }

    const handleClose = () => {
        setNotification({
          status: false,
          type: '',
          message: '',
        });
    };

    const onTransferReport=()=>{
        StudentTransferData({
            location :location,
            branch : branch,
            specialization: specialization,
            semesterTo : semesterTo ,
            sectionTo: sectionTo,
        },handleStudentTransferReport,handleStudentTransferReportException)
    }
 
    const handleStudentTransferReport= (dataObject) =>{
        setRows(dataObject);
        clearForm();  
    }

    const clearForm = () => {
        setLocation('');
        setBranch('');
        setSpecialization('');
        setSemester('');
        setSection('');
        setSemesterTo('');
        setSectionTo('');
        setRefreshData(oldValue => !oldValue);
    } 

    const handleStudentTransferReportException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    return (
        <div>
            <Grid container spacing={2} style={{ marginTop: '5px'}}>
                <Grid item xs={12} sm={12} md={6} lg={6} lx={6}>
                    <Paper elevation={3}>
                        <h1 style={{marginTop:'10px',marginBottom:'10px',justifyContent:"center",fontSize:'25px'}}>From</h1>
                        <hr />
                        <Grid container
                        direction="row-reverse"
                        justifyContent="center"
                        alignItems="center" spacing={2} style={{ marginTop: '5px' }}>
                            <Grid item xs={12} sm={11} md={11} lg={11} xl={11}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Location</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Location"
                                    placeholder='Location'
                                    value={location}
                                    required
                                    onChange={(e) => onLocationChange(e) }>
                                    {
                                        locationList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.location}</MenuItem>
                                            )
                                        })
                                    }      
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={11} md={11} lg={11} xl={11}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Hostel Name</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Hostel Name"
                                    placeholder='Hostel Name'
                                    value={branch}
                                    required
                                    onChange={(e) => onBranchChange(e) }>
                                        {
                                            branchList.length !== 0 ? (

                                            <MenuItem value="" key={0}>
                                            <em>Select Hostel Name</em>
                                            </MenuItem>
                                            )
                                        :
                                         (   <MenuItem value="" key={0}>
                                            <em>Select Location </em>
                                            </MenuItem>
                                        )}
                                    {
                                        branchList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.branch}</MenuItem>
                                            )
                                        })

                                    }        
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={11} md={11} lg={11} xl={11}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Specialization</InputLabel>
                                        <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Specialization"
                                        placeholder='Specialization'
                                        value={specialization}
                                        required
                                        onChange={(e) => onSpecializationChange(e) }>
                                            {
                                            specializationList.length !== 0 ? (

                                            <MenuItem value="" key={0}>
                                            <em>Select Specialization</em>
                                            </MenuItem>
                                            )
                                        :
                                         (   <MenuItem value="" key={0}>
                                            <em>Select Hostel Name </em>
                                            </MenuItem>
                                        )}
                                        {
                                            specializationList?.map((data, index) => {
                                                return (
                                                    <MenuItem value={data.id} key={index}>{data.specialization}</MenuItem>
                                                )
                                            })
                                        }       
                                        </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={11} md={11} lg={11} xl={11}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Year</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Year"
                                    placeholder='Year'
                                    value={semester}
                                    required
                                    onChange={(e) => onSemesterChange(e) }>
                                        {
                                            semesterList.length !== 0 ? (

                                            <MenuItem value="" key={0}>
                                            <em>Select Year</em>
                                            </MenuItem>
                                            )
                                        :
                                         (   <MenuItem value="" key={0}>
                                            <em>Select Specialization </em>
                                            </MenuItem>
                                        )}
                                    {
                                        semesterList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.semestersId} key={index}>{data.semester}</MenuItem>
                                            )
                                        })

                                    }      
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={11} md={11} lg={11} xl={11} style={{marginBottom:'10px'}}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Section</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Section"
                                    placeholder='Section'
                                    value={section}
                                    onChange={(e) => onSectionChange(e) }>
                                        {
                                    // sectionList.length !== 0 ? (

                                    // <MenuItem value="" key={0}>
                                    // <em>Select Section</em>
                                    // </MenuItem>
                                    // )
                                    // :
                                    (   <MenuItem value="" key={0}>
                                    <em>Select Year </em>
                                    </MenuItem>
                                    )}
                                    {
                                        sectionList?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.sectionsId} key={index+1}>{data.section}</MenuItem>
                                            )
                                        })
                                    }      
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            <Grid item  xs={12} sm={12} md={12} lg={12} lx={12} style={{marginBottom:'10px',marginRight:'5px'}}>
                                <Button  variant="contained" style={{float:'right'}} onClick={handleClickOpen}>View</Button>
                            </Grid> 
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} lx={6}>
                    <Paper elevation={3}  >
                        <h1 style={{marginTop:'10px',marginBottom:'10px',fontSize:'25px'}}>To</h1>
                        <hr />
                        <Grid container
                        direction="row-reverse"
                        justifyContent="center"
                        alignItems="center" spacing={2} style={{ marginTop: '5px' }}>
                            <Grid item xs={12} sm={11} md={11} lg={11} xl={11}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Year</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Year"
                                    placeholder='Year'
                                    value={semesterTo}
                                    required
                                    onChange={(e) => onSemesterToChange(e) }>
                                        
                                    {
                                        semesterListTo?.map((data, index) => {
                                            return (
                                                <MenuItem value={data.id} key={index}>{data.semester}</MenuItem>
                                            )
                                        })

                                    }      
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={11} md={11} lg={11} xl={11} style={{marginBottom:'10px'}}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Section</InputLabel>
                                    <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Section"
                                    placeholder='Section'
                                    value={sectionTo}
                                    onChange={(e) => onSectionToChange(e) }>
                                        {
                                    sectionListTo.length !== 0 ? (
                                    <MenuItem value="" key={0}>
                                    <em>Select Section</em>
                                    </MenuItem>
                                    )
                                    :
                                    (   <MenuItem value="" key={0}>
                                    <em>Select Year </em>
                                    </MenuItem>
                                    )}
                                    {
                                    sectionListTo?.map((data, index) => {
                                        return (
                                            <MenuItem value={data.sectionsId} key={index+1}>{data.section}</MenuItem>
                                        )
                                    })
                                    }      
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            <Grid item  xs={12} sm={12} md={12} lg={12} lx={12} style={{marginBottom:'10px',marginRight:'5px'}}>
                                <Button  variant="contained" style={{float:'right'}} onClick={onTransferReport}>Transfer</Button>
                            </Grid>  
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            <TransferView 
                open={open}
                setOpen={setOpen}
                setRefreshData={setRefreshData}
                handleClose={handleClose}
                rows={rows}
                setRows={setRows}
                location={location}
                branch={branch}
                specialization={specialization}
                semester={semester}
                section={section}
                semesterTo={semesterTo}
                sectionTo={sectionTo}
            />
        </div>
    )
}

export default StudentTransfer
